import React from 'react'
import _ from 'lodash'
import MapView from './MapView'

export default class MapComponent extends React.Component {
  state = {
    isMarkerShown: true,
    markers: this.props.markers,
  }

  componentWillMount() {}

  componentWillReceiveProps(nextProps) {
    if (!_.isEqual(nextProps.markers, this.props.markers)) {
      this.setState({
        markers: nextProps.markers,
      })
    }
  }

  handleMarkerDragEnd = event => {
    this.handleMarkerChange(event)
  }

  handleMapClick = event => {
    const { lat, lng } = this.getLatLng(event)
    this.setState(
      {
        markers: [this.createMarker(lat, lng)],
      },
      () => this.handleMarkerChange(event),
    )
  }

  handleMarkerChange = event => {

    const latLng = this.getLatLng(event)

    this.setState({
      center: latLng,
    })

    if (this.props.onMarkerChange) {
      this.props.onMarkerChange(latLng)
    }
  }

  getLatLng = event => {
    const latLng = event.latLng
    let lat = latLng.lat()
    let lng = latLng.lng()
    return { lat, lng }
  }

  createMarker = (lat, lng) => {
    return {
      position: { lat, lng },
    }
  }

  render() {
    return (
      <MapView
        {...this.props}
        center={this.state.center}
        markers={this.state.markers}
        isMarkerShown={this.state.isMarkerShown}
        onMarkerDragEnd={this.handleMarkerDragEnd}
        onMapClick={this.handleMapClick}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/map/MapComponent.js